var React = require('react');

function CarouselArrowPrev (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.799995 16C0.799995 15.7334 0.84444 15.4889 0.933329 15.2667C1.02222 15.0445 1.17777 14.8223 1.39999 14.6L14.6 1.40003C14.9556 1.04448 15.4333 0.87781 16.0333 0.900032C16.6333 0.922254 17.1111 1.11114 17.4667 1.4667C17.9111 1.91114 18.1 2.38892 18.0333 2.90003C17.9667 3.41114 17.7555 3.8667 17.4 4.2667L5.66666 16L17.4 27.7334C17.7555 28.0889 17.9556 28.5667 18 29.1667C18.0444 29.7667 17.8444 30.2445 17.4 30.6C17.0444 31.0445 16.5778 31.2334 16 31.1667C15.4222 31.1 14.9333 30.8889 14.5333 30.5334L1.39999 17.4C1.17777 17.1778 1.02222 16.9556 0.933329 16.7334C0.84444 16.5111 0.799995 16.2667 0.799995 16Z","fill":"#AAAAAA"}));
}

CarouselArrowPrev.defaultProps = {"width":"19","height":"32","viewBox":"0 0 19 32","fill":"none"};

module.exports = CarouselArrowPrev;

CarouselArrowPrev.default = CarouselArrowPrev;
